import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './paths'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '../store'
import UserService from '../services/UserService'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const authRequired = !to.meta.public
  const isLoggedIn = store.getters.LOGGED_IN
  let paymentSuccess = false

  if (authRequired && !isLoggedIn) {
    next({ name: 'Login' })
    return
  }

  if (!authRequired && isLoggedIn) {
    NProgress.start()
    UserService.getMe().then(resp => {
      let response = resp.data
      if (response.status === 200 && response.data) {
        let user = response.data
        let dealer = user.dealer
        if (!dealer && user.roles.includes('admin')) {
          next({ name: 'User' })
          return
        }
        paymentSuccess = dealer?.balance.subscription_status === 'active' || dealer?.balance.subscription_status === 'trialing'

        if (!paymentSuccess && to.name !== 'Payment') {
          next({ name: 'Payment' })
        } else if (paymentSuccess && to.name === 'Login') {
          next({ name: 'Vehiculo' })
        } else {
          next()
        }
      } else {
        next({ name: 'Login' })
      }
    }).catch(() => {
      next({ name: 'Login' })
    })
    return
  }

  NProgress.start()
  next()
})

router.afterEach((to, from) => {
  // definiendo el título de la aplicación para cada página
  document.title = to.meta.title + ' | Pivot Fleet'

  NProgress.done()
})

export default router
